import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./../../../App";
import { autoHypenPhone } from "@src/utils";
import { chkPhoneTel } from "./../../../utils/index";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useRecommendHall } from "../../../utils/hooks/useRecommendHall";
import { postRecommendHall } from "../../../api/recommend/recommend";
import { setCustomer, setCustomerUuid, setOverrideData } from "@src/@slice/recommendHallSlice";
import { FormBlock, FormWrap } from "@src/components/form/formBlock/FormBlock";
import InputBox from "@src/components/form/inputBox/base/InputBox";
import { Blank } from "@src/shared/src";
import { getOs } from "@src/utils";
import { closeWebview } from "@src/utils/route";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";

const CustomerInfo = () => {
  const user = useContext(UserContext);
  const navigate = useNavigate();
  const { hallData, dispatch, isComplete } = useRecommendHall();
  const customer = hallData.customer;

  const isiOS = getOs() === "ios";

  const [validate, setValidate] = useState(true);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(user.me.customerName || customer.name);

  const postRecommend = () => {
    sessionStorage.removeItem("recommendHallData");
    if (isComplete) {
      alert("이미 신청된 양식입니다.");
      return;
    }
    if (loading) return;
    setLoading(true);
    postRecommendHall({
      ...hallData,
    })
      .then((res) => {
        setLoading(false);
        navigate("/recommend/hall/complete");
      })
      .catch((err) => {
        alert("error!");
        setLoading(false);
        console.log(err);
      });
  };

  const nameCheck = (string) => {
    const nameRegex = /^[가-힣a-zA-Z\s]{2,}$/;
    return nameRegex.test(string);
  };

  useEffect(() => {
    const customer = hallData.customer;

    if (
      customer.tel.trim() === "" ||
      customer.name.trim() === "" ||
      !chkPhoneTel(customer.tel, "PHONE") ||
      !nameCheck(customer.name)
    ) {
      setValidate(false);
    } else if (customer.name !== "" && !nameCheck(customer.name)) {
      setValidate(false);
    } else {
      setValidate(true);
    }
  }, [hallData.customer]);

  useEffect(() => {
    if (isComplete) {
      window.location.href = "h2mwbell://webview/close";
    }
    if (user.me) {
      if (sessionStorage.getItem("recommendHallData")) {
        const recommendHallData = JSON.parse(sessionStorage.getItem("recommendHallData") || "{}");
        dispatch(setOverrideData({ data: recommendHallData }));
      }

      dispatch(setCustomerUuid({ uuid: user.me.uuid }));
      if (user.me.sex && customer.role === "") {
        dispatch(setCustomer({ key: "role", data: user.me.sex === 1 ? "BRIDE" : "GROOM" }));
      }
      if (user.me.customerName && customer.name === "") {
        dispatch(setCustomer({ key: "name", data: user.me.customerName }));
      }
      if (user.me.tel) {
        dispatch(setCustomer({ key: "tel", data: user.me.tel }));
      }
    }
  }, [user.me]);

  const goMyTel = () => {
    console.log(hallData, "hallData");
    sessionStorage.setItem("recommendHallData", JSON.stringify(hallData));
    navigate("/mypage/my-tel");
  };

  return (
    <div className="recommend-hall-customer-info">
      <CustomHeader
        goBack={() => navigate("/recommend/hall/hope-date")}
        close={closeWebview}
        headerPostion="fixed"
      />
      <PageTitle title={`신청자 정보를 확인해주세요.`} />
      <p className="customer-info-text">
        {` 앱 가입 정보로 웨딩홀 추천 리스트를 발송해 드립니다.
       *웨딩홀에 전달되거나 다른 용도로 활용되지 않습니다.`}
      </p>
      <div className="common-wrap">
        <FormWrap>
          <FormBlock
            title=""
            typeStr=""
            content={
              <ul className="my-role-list-wrap">
                {customer.role === "BRIDE" ? (
                  <li
                    className={"on"}
                    onClick={() => dispatch(setCustomer({ key: "role", data: "BRIDE" }))}
                  >
                    신부
                  </li>
                ) : (
                  <li
                    className={"on"}
                    onClick={() => dispatch(setCustomer({ key: "role", data: "BRIDE" }))}
                  >
                    신랑
                  </li>
                )}
              </ul>
            }
          />
          <FormBlock
            title="이름"
            typeStr=""
            content={
              <InputBox
                type="text"
                className="input-text input-full"
                placeholder="이름"
                value={customer.name}
                showHelpTextError={customer.name !== "" && !nameCheck(customer.name)}
                showErrorBorder={customer.name !== "" && !nameCheck(customer.name)}
                onChange={(e) => dispatch(setCustomer({ key: "name", data: e.target.value }))}
                onBlur={(e) => dispatch(setCustomer({ key: "name", data: e.target.value }))}
                resultObj={{
                  result: "error",
                  message: "올바른 이름을 입력해주세요.",
                }}
                disabled={name !== "" && nameCheck(name)}
              />
            }
          />
          <FormBlock
            title="전화번호"
            typeStr=""
            content={
              <InputBox
                type="tel"
                className="input-text input-full"
                placeholder="01012345678"
                defaultValue={autoHypenPhone(customer.tel)}
                value={autoHypenPhone(customer.tel)}
                onChange={(e) => {
                  const tel = autoHypenPhone(e.target.value);
                  dispatch(setCustomer({ key: "tel", data: tel }));
                }}
                onKeyDown={(e) => {
                  if (e.key.toLowerCase() !== "backspace" && customer.tel.length >= 13) {
                    e.preventDefault();
                  }
                }}
                style={{
                  paddingTop: "8px",
                }}
                showHelpTextError={
                  customer.tel.trim() !== "" && !chkPhoneTel(customer.tel, "PHONE")
                }
                showErrorBorder={customer.tel.trim() !== "" && !chkPhoneTel(customer.tel, "PHONE")}
                resultObj={{
                  result: "error",
                  message: "올바른 전화번호를 입력해주세요.",
                }}
                disabled={true}
              />
            }
          />
          <p className="change-tel-text" onClick={goMyTel}>
            전화번호가 변경되었나요?
          </p>
        </FormWrap>
        <Blank height={80} />
      </div>
      <div className="gradient-background"></div>
      <button
        className={`btn btn-giant btn-full ${validate === false ? "btn-disabled" : "btn-red500 "}`}
        onClick={postRecommend}
        // disabled={customer.name !== "" && !nameCheck(customer.name)}
      >
        완료
      </button>
      {isiOS && <Blank height={20} />}
    </div>
  );
};

export default CustomerInfo;
